import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import TableHeader from './tableHeader';
import TableBody from './tableBody';
import { API_URL } from '../../config';
import CustomButtons from '../Elements/Buttons/customButton';
import './to_pay.css';
import axios from 'axios';
import IconPayment from './iconPayment';
import CustomTittle from '../../components/Elements/customTittle/customTittle'
const PaymentHistory = (props) => {
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [saldo, setSaldo] = useState('');
    const apiService = ApiService.getInstance();
    const token = localStorage.getItem('token');
    const [res, setRes] = useState([]);
    const proxySendURL = `${API_URL}ProxySend`;
    let test = [];
    let amount = 0;
    const [toPay, setToPay] = useState([]);
    const [amountFree, setAmount] = useState(0);

    function toPayChange(p, a) {
        let payment = toPay;

        if (toPay.includes(p)) {
            const arrayWithoutD = payment.filter(function (letter) {
                return letter !== p;
            });

            setAmount(amountFree - a);
            setToPay(arrayWithoutD);
        } else {
            setAmount(amountFree + a);
            setToPay([...toPay, p]);
        }
    }

    const payload = {
        keyController: 'getAllPaymentByUsersID',
        usersID: props.userID,
        current_LocalizationsID: '0',
    };
    let globalResponse;

    const methodProxySend = () => {
        apiService.apiPost('CalculateProductForUser', payload, (response) => {
            if (response.success) {
               
                let arr = response.data.responseBody.body;

                setRes(arr);
            }
        });
    };
    function calculateAmount(d, p, a) {
        if (comapreDates(d)) {
            test.push(p);
            amount += a;
        }
    }

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                  
                    if (proxyGetMessageUrlResponse.data.responseBody.status == 400) {
                        // history.push('/Error_ogolny');
                        console.log('error');
                    }
                    console.log(proxyGetMessageUrlResponse);
                    if (proxyGetMessageUrlResponse.data.responseBody.body.html) {
                       
                        localStorage.setItem(
                            'pushURL',
                            proxyGetMessageUrlResponse.data.responseBody.body.html
                        );
                        // setMsg("Twoja umowa jest gotowa! Możesz przejść dalej")
                        // window.location.replace();
                    } else if (proxyGetMessageUrlResponse.data.responseBody.body.key === 20) {
                        
                        //  history.push(`/Potwierdzenie_zakupu/${proxyGetMessageUrlResponse.data.responseBody.body.sessionID}`);
                    }
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 10000);
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        // history.push('/Error_ogolny');
                    }
                } else {
                    // window.location.replace(
                    //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                    // );
                }
            });
    };
    const getUsersSaldo = async () => {
        await apiService.asyncApiPost('getUserSaldo', config).then((response) => {
            console.log('saldo: ', response);
            // setSaldo(response.responseBody.body[0].saldo);
        });
        return 'Finished methodCheckUserEntryFee';
    };
    useEffect(() => {
        props.setHeader('/  HISTORIA PŁATNOŚCI');
        //getUsersSaldo();
        if (props.userID != undefined) {
            methodProxySend();
        }
    }, [props.userID]);
    function comapreDates(d, p) {
        const x = new Date();
        const y = new Date(d);

        if (x < y) {
            return false;
        } else {
            return true;
        }
    }

    function expandDetails(id) {
        let elArr = document.querySelectorAll(`[id='${id}']`);
        elArr.forEach((el) => {
            if (el.hidden) el.hidden = false;
            else el.hidden = true;
        });
        document.getElementById(`parent_${id}`).dataset.expanded = !document.getElementById(
            `parent_${id}`
        ).dataset.expanded;
    }

    return (
        <>  <div className="pastpaymentTittle">
            <CustomTittle size={'h4'}>HISTORIA PŁATOŚCI</CustomTittle>
            </div>
            <div className="dashboard__content">
                <main>
                    <div className="responsive-table margin-top-8 tablePay">
                    <div className="responsiveTableWrapper">
                        <table className="no__spacing">
                            <thead className="boardHead">
                                <tr className="headTable_installemnt ">
                                    <th style={{ width: '10%' }}>Nr płatności</th>
                                    <th style={{ width: '10%' }}>Typ produktu</th>
                                    <th style={{ width: '10%' }}>Nazwa pozycji</th>
                                    <th style={{ width: '10%' }}>Płatnik</th>
                                    <th style={{ width: '10%' }}>Data płatności</th>
                                    <th style={{ width: '10%' }}>Kwota</th>
                                    <th style={{ width: '10%' }}>Status</th>
                                    <th style={{ width: '10%' }}></th>
                                </tr>
                            </thead>
                            <tbody className="board" id={'tbodyBoard'}>
                                {res.map((pay, index) => {
                                    return (
                                        <div>
                                            <tr
                                                className="oddRowTable_installemnt"
                                                id={`parent_${pay.paymentsID}`}
                                                hidden={false}
                                                key={index}
                                            >
                                                <td style={{ width: '10%' }}>{pay.paymentsID}</td>
                                                <td style={{ width: '10%' }}>
                                                    {pay.productTapeName}
                                                </td>
                                                <td style={{ width: '10%' }}>{pay.itemName}</td>

                                                <td style={{ width: '10%' }}>{pay.fullName}</td>
                                                <td style={{ width: '10%' }}>{pay.paymentDate}</td>
                                                <td style={{ width: '10%' }}>
                                                    {pay.paymentItemAmount
                                                        .toFixed(2)
                                                        .replace('.', ',')}
                                                </td>
                                                <td style={{ width: '10%' }}>
                                                    {pay.paymentStatusesName}
                                                </td>
                                                <td style={{ width: '10%' }}>
                                                    <IconPayment id={pay.paymentsID} />
                                                </td>
                                            </tr>
                                            {pay.allPayments.map((el) => {
                                                return (
                                                    <tr
                                                        className="oddRowTable_installemnt"
                                                        id={el.paymentsID}
                                                        hidden={true}
                                                        key={index}
                                                    >
                                                        <td style={{ width: '10%' }}>
                                                            {el.paymentsID}
                                                        </td>
                                                        <td style={{ width: '10%' }}>
                                                            {el.productTapeName}
                                                        </td>
                                                        <td style={{ width: '10%' }}>
                                                            {el.itemName}
                                                        </td>

                                                        <td style={{ width: '10%' }}>
                                                            {el.fullName}
                                                        </td>
                                                        <td style={{ width: '10%' }}>
                                                            {el.paymentDate}
                                                        </td>
                                                        <td style={{ width: '10%' }}>
                                                            {el.paymentItemAmount
                                                                .toFixed(2)
                                                                .replace('.', ',')}
                                                        </td>
                                                        <td style={{ width: '10%' }}>
                                                            {el.paymentStatusesName}
                                                        </td>
                                                        <td style={{ width: '10%' }}>{''}</td>
                                                    </tr>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div></div>
                </main>
            </div>
        </>
    );
};

export default PaymentHistory;
